import * as React from 'react'
import { connect } from 'react-redux'
import { ApplicationState } from '../../store'
import SearchBox from '../courses/searchBox';
import { fetchRequest as getCourseRecomAction} from '../../store/courseRecommend/actions'
import { getCourseRecom } from '../../store/courseRecommend/selectors';
import {
    Container, Col, Row, Card, CardImg, CardTitle, CardText, CardGroup, CardFooter,
    CardSubtitle, CardBody, Spinner, Button
} from 'reactstrap';
import { NavLink as RouterNavLink } from 'react-router-dom';
import '@fortawesome/fontawesome-free/css/all.css';
import { Redirect } from 'react-router-dom';

interface PropsFromState {
    route: any
    data: any
    loading: boolean
    totalDoc: number
}

interface IState {
    redirect: boolean
    term : string
    profession : string
    country : string
    sorting : string
    offset: number
    limit: number
}

interface PropsFromDispatch {
    fetchRequest : typeof getCourseRecomAction
}

type AllProps = PropsFromState & PropsFromDispatch

class Help extends React.Component<AllProps, IState> {

    constructor(props: AllProps) {
        super(props);
        this.state = {
            term : '',
            profession : '',
            country:'',
            sorting: '',
            offset : 0,
            limit: 4,
            redirect: false
        };
        //this.Search = this.Search.bind(this);
    }

    public componentDidMount() {
        const { fetchRequest: fr, data } = this.props
        var searchParams:any = {};
        searchParams["offset"] = this.state.offset;
        searchParams["limit"] = this.state.limit;
        if (data.length === 0)
           fr(searchParams);
    }

    private Search(d:any) { 

       this.setState({
            offset : 0, 
            redirect : true,
            term : d.searchTerm.toLowerCase(), 
            profession : d.searchProfession, 
            country : d.searchCountry}, () => {
        });
    }
   
    public render() {

        if (this.state.redirect){
            return (
                <Redirect push to={{
                    pathname: '/courses/' ,
                    search :'?term=' + this.state.term  + "&profession=" + encodeURIComponent(this.state.profession) + "&country=" + this.state.country    
                }} />
                // <Redirect to={"/courses?term=" + this.state.term 
                //     + "&profession=" + this.state.profession
                //     + "&country=" + this.state.country    
                //  } />
            )
        }else{
            return (        
                <Container>
                   <h1>Help</h1>
                   <hr/>
                   <p>
                   Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ips
                   </p>
                   <p>
                   Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ips
                   </p>
                   <p>
                   Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ips
                   </p>
                </Container>
            )
        }
    }
}

const mapStateToProps = (state: ApplicationState) => ({
    loading: state.course.ui.loading,
    totalDoc: state.course.ui.totDoc,
    errors: state.course.ui.errors,
    data: getCourseRecom(state)
})

// mapDispatchToProps is especially useful for constraining our actions to the connected component.
// You can access these via `this.props`.
const mapDispatchToProps = {
    fetchRequest: getCourseRecomAction
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(Help)
